import ConstantApi from '../../ConstantApi';
import axiosCall from '../axiosCall';
import {
    CREATE_UNIT_MASTER_FAILURE,
    CREATE_UNIT_MASTER_REQUEST,
    CREATE_UNIT_MASTER_SUCCESS,
    CREATE_USER_FORM_UNIT_MASTER,
    DELETE_UNIT_MASTER_FAILURE,
    DELETE_UNIT_MASTER_REQUEST,
    DELETE_UNIT_MASTER_SUCCESS,
    FETCH_SINGLE_UNIT_MASTER_FAILURE,
    FETCH_SINGLE_UNIT_MASTER_REQUEST,
    FETCH_SINGLE_UNIT_MASTER_SUCCESS,
    FETCH_UNIT_MASTER_BY_COMPANYID_FAILURE,
    FETCH_UNIT_MASTER_BY_COMPANYID_REQUEST,
    FETCH_UNIT_MASTER_BY_COMPANYID_SUCCESS,
    FETCH_UNIT_MASTER_FAILURE,
    FETCH_UNIT_MASTER_REQUEST,
    FETCH_UNIT_MASTER_SUCCESS,
    UNIT_AREA_FROM_AREA_TABLE_FOR_DROPDOWN_FAILURE,
    UNIT_AREA_FROM_AREA_TABLE_FOR_DROPDOWN_REQUEST,
    UNIT_AREA_FROM_AREA_TABLE_FOR_DROPDOWN_SUCCESS,
    UNIT_MASTER_USERFORM_RESET,
    UNIT_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_FAILURE,
    UNIT_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_REQUEST,
    UNIT_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_SUCCESS,
    UPDATE_UNIT_MASTER_FAILURE,
    UPDATE_UNIT_MASTER_REQUEST,
    UPDATE_UNIT_MASTER_SUCCESS
} from './unitMaster.actionsType';

// FETCH PROPERTY MASTER
export let fetchUnitMaster = () => {
    let config = {
        method: 'get',
        url: ConstantApi.unitMasterGET,
        responseTypeRequest: FETCH_UNIT_MASTER_REQUEST,
        responseTypeSuccess: FETCH_UNIT_MASTER_SUCCESS,
        responseTypeFailure: FETCH_UNIT_MASTER_FAILURE
    };
    return axiosCall(config);
};

export let fetchUnitMasterByCompanyId = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.unitMasterGET_BY_ID}?FldFKCompany=${id}`,
        responseTypeRequest: FETCH_UNIT_MASTER_BY_COMPANYID_REQUEST,
        responseTypeSuccess: FETCH_UNIT_MASTER_BY_COMPANYID_SUCCESS,
        responseTypeFailure: FETCH_UNIT_MASTER_BY_COMPANYID_FAILURE
    };
    return axiosCall(config);
};

// create user Form
export let createUnitUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_UNIT_MASTER, updatePayload: { key, value } });
    };
};

//call property from property table
export let fetchUnitPropertyUnitMaster = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.PropertyList}/5`,
        responseTypeRequest: UNIT_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_REQUEST,
        responseTypeSuccess: UNIT_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_SUCCESS,
        responseTypeFailure: UNIT_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_FAILURE
    };
    return axiosCall(config);
};

export let fetchAreaUnitMaster = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.areaMasterGET}`,
        responseTypeRequest: UNIT_AREA_FROM_AREA_TABLE_FOR_DROPDOWN_REQUEST,
        responseTypeSuccess: UNIT_AREA_FROM_AREA_TABLE_FOR_DROPDOWN_SUCCESS,
        responseTypeFailure: UNIT_AREA_FROM_AREA_TABLE_FOR_DROPDOWN_FAILURE
    };
    return axiosCall(config);
};

// CREATE PROPERTY MASTER
export let createUnitMasterCompany = (formData, modalClose) => {
    let today = new Date();
    let data = JSON.stringify({
        fldFKCompany: formData.companyId,
        fldCode: 'Auto Generated',
        fldName: formData.name,
        fldShortName: formData.shortName,
        fldAddress1: formData.address1,
        fldAddress2: formData.address2,
        fldFKArea: parseInt(formData.area),
        fldGSTNo: formData.gstNo,
        fldPANNo: formData.panNo,
        fldContactPerNme: formData.CName,
        fldMobileNo: formData.mobile,
        fldMailId: formData.mail,
        fldFKUnitCategory: parseInt(formData.unitType),
        fldIsHeaderInfo: false,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString()
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.unitMasterPOST}`,
        responseTypeRequest: CREATE_UNIT_MASTER_REQUEST,
        responseTypeSuccess: CREATE_UNIT_MASTER_SUCCESS,
        responseTypeFailure: CREATE_UNIT_MASTER_FAILURE,
        resetFormData: UNIT_MASTER_USERFORM_RESET,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchUnitMasterByCompanyId(formData.companyId)
    };
    return axiosCall(config);
};

// GET SINGLE PROPERTY MASTER
export let getSingleUnitMaster = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.unitMasterGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_UNIT_MASTER_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_UNIT_MASTER_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_UNIT_MASTER_FAILURE,
        singlApiArray: [fetchAreaUnitMaster(), fetchUnitPropertyUnitMaster()]
    };
    return axiosCall(config);
};

//UPDATE PROPERTY MASTER
export let updateUnitMaster = (id, formData) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: parseInt(id),
        fldFKCompany: parseInt(formData.companyId),
        fldCode: formData.code,
        fldName: formData.name,
        fldShortName: formData.shortName,
        fldAddress1: formData.address1,
        fldAddress2: formData.address2,
        fldFKArea: parseInt(formData.area),
        fldGSTNo: formData.gstNo,
        fldPANNo: formData.panNo,
        fldContactPerNme: formData.CName,
        fldMobileNo: formData.mobile,
        fldMailId: formData.mail,
        fldFKUnitCategory: parseInt(formData.unitType),
        fldIsHeaderInfo: false,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,
        fldModifiedBy: 1,
        fldModifiedDt: today.toISOString()
    });
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.unitMasterPATCH}/${id}`,
        responseTypeRequest: UPDATE_UNIT_MASTER_REQUEST,
        responseTypeSuccess: UPDATE_UNIT_MASTER_SUCCESS,
        responseTypeFailure: UPDATE_UNIT_MASTER_FAILURE,
        resetFormData: UNIT_MASTER_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchUnitMasterByCompanyId(formData.companyId)
    };
    return axiosCall(config);
};

// DELETE PROPERTY MASTER

export let deleteUnitMaster = (id, companyId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.unitMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_UNIT_MASTER_REQUEST,
        responseTypeSuccess: DELETE_UNIT_MASTER_SUCCESS,
        responseTypeFailure: DELETE_UNIT_MASTER_FAILURE,
        modalClose: true,
        getAllData: fetchUnitMasterByCompanyId(companyId)
    };
    return axiosCall(config);
};
